import * as React from 'react';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';
import { toggleBackgroundJobExtendedInfoDialog } from '../actions/ToggleBackgroundJobExtendedInfoDialog';
import { appStore } from '../../app/AppStore';

export class BackgroundJobExtendedInfoDialogCell extends React.Component<IBackgroundJobInfo> {

  private readonly toggleDilog = () => {
    appStore.dispatch(toggleBackgroundJobExtendedInfoDialog(this.props));
  }

  render() {
    return <>
      <a data-tb-test-id="data-grid-cell-text" onClick={this.toggleDilog} role="button">
        {this.props.jobId + ''}
      </a>
    </>;
  }
}
